<template>
<div class="settings">
    <div class="columns">
        <div class="column is-one-quarter">
            <div class="columns">
                <div class="column is-11">
                    <settings-menu active-item="encryptionKeys"></settings-menu>
                </div>
            </div>
        </div>
        <div class="column">
            <div class="settings-container">
                <div class="columns is-multiline">
                    <div v-if="loadingEncryptionKeys" class="column is-full has-text-centered">
                        <img src="/loader-dark.svg">
                    </div>
                    <div v-if="!loadingEncryptionKeys" class="column is-full">
                        <div class="columns is-multiline">
                            <!-- <div class="column is-12">
                                <div class="notification is-default" style="font-size: 13px;">
                                    Storages are required only for <b><router-link :to="{ name: 'databases' }">Database Backups</span></router-link></b> and <b><router-link :to="{ name: 'files' }">File Backups</span></router-link></b>. If you use <b><router-link :to="{ name: 'cloudlets' }">Provider Snapshots</span></router-link></b>, a storage is not required because the snapshots are stored directly inside the cloud provider infrastructure.
                                </div>
                            </div> -->
                            <div class="column is-3">
                                <div class="plan-page-label">Encryption keys</div>
                                <div class="plan-page-description" style="font-size:13px !important;">
                                    Encryption keys are pairs of public & private keys that are used to encrypt your Database backups.
                                </div>
                                <div class="plan-page-description" style="font-size:13px !important;">
                                    Once genrated, you must keep your private key secure. Without it, you will not be able to decrypt your backups.
                                </div>
                                <div @click="showGenerateEncryptionKeyModal" class="button custom-button-size is-fullwidth is-info m-top-20">Create encryption key</div>
                            </div>
                            <div class="column is-9" style="padding-left: 60px;">
                                <div class="columns is-multiline">
                                    <div class="column is-full">
                                        <div v-if="encryptionKeysLoadedOnce && encryptionKeys.length < 1" class="notification is-default" style="font-size: 13px;">
                                            You don't have an encryption key generated at the moment. Use the button <strong>Create encryption key</strong> to generate one.
                                        </div>
                                    </div>
                                    <div v-for="encryptionKey in encryptionKeys" v-bind:key="encryptionKey.id" class="column is-half">
                                        <!-- <router-link :to="{ name: 'storageSettings', params: { id: encryptionKey.id } }"> -->
                                        <div class="plan provider-box" style="border-radius:6px !important; cursor:default !important;">
                                            <div class="plan-details">
                                                <div class="columns is-multiline">
                                                    <div class="column is-11" style="padding-bottom:0;">
                                                        <div class="plan-period" style="font-weight: 700; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ encryptionKey.name }}</div>
                                                    </div>
                                                    <!-- <div class="column has-text-right is-1"  style="padding-bottom:0; min-height: 40px;">
                                                        <span v-if="storage.is_default" class="tag is-success is-small">Default</span>
                                                    </div> -->
                                                    <div class="column is-half">
                                                        <div class="plan-price">
                                                            <span class="plan-resource">Backups encrypted</span>
                                                        </div>
                                                    </div>
                                                    <div class="column is-half has-text-right">
                                                        <span class="plan-period" style="font-weight: 700;">{{ encryptionKey.backups_count }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- </router-link> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <generate-encryption-key v-if="generateEncryptionKeyModalVisible"></generate-encryption-key>
</div>
</template>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';
import FormErrorsMixin from '@/mixins/FormErrors';

import SettingsMenu from '@/components/Settings/Menu.vue';
import GenerateEncryptionKey from '@/components/Settings/GenerateEncryptionKey.vue';

export default {
    components: {
        SettingsMenu,
        GenerateEncryptionKey,
    },

    mixins: [FormErrorsMixin],

    metaInfo: {
        title: 'Encryption keys - Weap.io',
    },

    data() {
        return {
            encryptionKeys: [],
            loadingEncryptionKeys: false,
            encryptionKeysLoadedOnce: false,
            generateEncryptionKeyModalVisible: false,
            //
            storages: [],
            addStorageModalVisible: false,
            loadingEncryptionKeys: false,
        }
    },

    mounted() {
        this.getEncryptionKeys();
        this.listenEvents();
    },

    // beforeRouteEnter(to, from, next) {
        // next(vm => {
        //     if (vm.$route.query.storage_deleted) {
        //         swal('Success!', 'The storage was deleted.', 'success');
        //     }
        // });
    // },

    methods: {
        getEncryptionKeys(successCallback) {
            if (this.loadingEncryptionKeys) {
                return;
            }

            this.loadingEncryptionKeys = true;

            Api().get('encryption-keys')
                .then((response) => {
                    this.encryptionKeys = response.data.data;
                    if (typeof successCallback == 'function') {
                        successCallback();
                    }
                })
                .catch((error) => {
                    //
                })
                .finally(() => {
                    this.loadingEncryptionKeys = false;
                    this.encryptionKeysLoadedOnce = true;
                });
        },

        showGenerateEncryptionKeyModal() {
            this.generateEncryptionKeyModalVisible = true;
        },

        listenEvents() {
            Event.$on('generateEncryptionKeyModalClosed', () => {
                this.generateEncryptionKeyModalVisible = false;
            });

            Event.$on('refreshEncryptionKeys', (successCallback) => {
                this.getEncryptionKeys(successCallback);
            });
        },
    },
}
</script>
